import { render, staticRenderFns } from "./ProductModelView.vue?vue&type=template&id=60e42c20&scoped=true&"
import script from "./ProductModelView.vue?vue&type=script&lang=js&"
export * from "./ProductModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e42c20",
  null
  
)

export default component.exports